// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// CourseSearchHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import CourseDetailDTO from '../models/CourseDetailDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    disciplineId: string | null | null;
    catalogNumber: string | null;
    title: string | null;
    institutionId: string | null | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            disciplineId: null,
            catalogNumber: "",
            title: "",
            institutionId: null,
        },
        initValues);
    },
    disciplineId: 'disciplineId',
    catalogNumber: 'catalogNumber',
    title: 'title',
    institutionId: 'institutionId',
}

interface Result extends ResultDTO {
    courses: CourseDetailDTO[] | null;
    exceedsNumberOfCourses: boolean;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            courses: [],
            exceedsNumberOfCourses: false,
        },
        initValues);
    },
    courses: 'courses',
    exceedsNumberOfCourses: 'exceedsNumberOfCourses',
}

export { Request, Result };